import getcapital from './getcapital';
import GetCapital from '../Components/svg/GetCapital';

const theme = getcapital.theme;

export const headerLogo = GetCapital;

export default {
  theme,
  headerLogo,
};
